/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Composite } from '../models/Composite';
import type { CompositeComment } from '../models/CompositeComment';
import type { CompositeDataCut } from '../models/CompositeDataCut';
import type { CompositeDataCutAdjustmentDetails } from '../models/CompositeDataCutAdjustmentDetails';
import type { CompositeHistory } from '../models/CompositeHistory';
import type { DataCutDisplayMode } from '../models/DataCutDisplayMode';
import type { EmployeeData } from '../models/EmployeeData';
import type { PriceJobMode } from '../models/PriceJobMode';
import type { PricingPolicyType } from '../models/PricingPolicyType';
import type { SortDirection } from '../models/SortDirection';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompositeService {

    /**
     * Get composites
     * @returns any Success
     * @throws ApiError
     */
    public static getComposites({
        requestBody,
    }: {
        requestBody: {
            plan?: Array<number>;
            paymarket?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
            compositeIds?: Array<number>;
            isIndexed?: boolean;
            limit?: number;
            offset?: number;
            sort?: {
                companyJobTitle?: SortDirection;
                companyJobCode?: SortDirection;
                paymarketName?: SortDirection;
            };
        },
    }): CancelablePromise<{
        rows: Array<Composite>;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get composites history
     * @returns any Success
     * @throws ApiError
     */
    public static getCompositesHistory({
        limit,
        offset,
    }: {
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
    }): CancelablePromise<{
        rows: Array<CompositeHistory>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/history',
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Mass Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static addMassCompositeDataCut({
        requestBody,
    }: {
        requestBody: {
            paymarketId: number;
            surveyId: string;
            dataCutId: string;
            jobFamilyId?: Array<number>;
            jobSubFamilyId?: Array<number>;
            jobLevelId?: Array<number>;
            jobMode?: PriceJobMode;
            tagId?: Array<number>;
            search?: string;
        },
    }): CancelablePromise<Array<{
        compositeId?: number;
        companyId?: number;
        planId?: number;
        paymarketId?: number;
        isIndexed?: number;
    }>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/mass',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Mass Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static deleteMassCompositeDataCut({
        requestBody,
    }: {
        requestBody: {
            paymarketId: number;
            surveyId: string;
            dataCutId: string;
            jobFamilyId?: Array<number>;
            jobSubFamilyId?: Array<number>;
            jobLevelId?: Array<number>;
            jobMode?: PriceJobMode;
            tagId?: Array<number>;
            search?: string;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/mass-delete',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Reset Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static resetMassCompositeDataCut({
        requestBody,
    }: {
        requestBody: {
            planId: number;
            paymarketId?: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/reset',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export to excel
     * @returns any Success
     * @throws ApiError
     */
    public static exportToExcel({
        dataCutDisplayMode,
        composites,
    }: {
        /**
         * Data Cut Display Mode
         */
        dataCutDisplayMode: DataCutDisplayMode,
        /**
         * Composite ids
         */
        composites: Array<number>,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/export/summary',
            query: {
                'dataCutDisplayMode': dataCutDisplayMode,
                'composites': composites,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Pricing Policy
     * @returns any Success
     * @throws ApiError
     */
    public static updateCompositePricingPolicy({
        requestBody,
    }: {
        requestBody: {
            policyType: PricingPolicyType;
            policyId: number | null;
            plan?: Array<number>;
            paymarket?: Array<number>;
            jobFamily?: Array<number>;
            jobSubFamily?: Array<number>;
            jobLevel?: Array<number>;
            search?: string;
            composite?: Array<number>;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/pricingPolicy',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Composite Data Cut List
     * @returns CompositeDataCut Success
     * @throws ApiError
     */
    public static getCompositeDataCutList({
        compositeId,
        sort,
        dataCutDisplayMode,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Sorting
         */
        sort?: {
            surveyName?: SortDirection;
            surveyVendorName?: SortDirection;
            weight?: SortDirection;
        },
        /**
         * Data Cut Display Mode
         */
        dataCutDisplayMode?: DataCutDisplayMode,
    }): CancelablePromise<Array<CompositeDataCut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/datacut',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'sort': sort,
                'dataCutDisplayMode': dataCutDisplayMode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Composite Data Cuts
     * @returns any Success
     * @throws ApiError
     */
    public static addCompositeDataCuts({
        compositeId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        requestBody: {
            surveyData: Array<{
                surveyDataId: string;
                surveyId: string;
                adjustment?: number;
                weight?: number;
            }>;
            removeUnusedJobMappings?: boolean;
            createLocalMappings?: boolean;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/{compositeId}/datacut',
            path: {
                'compositeId': compositeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * get adjustment and weight details
     * @returns CompositeDataCutAdjustmentDetails Success
     * @throws ApiError
     */
    public static getCompositeDataCutAdjustmentDetails({
        compositeId,
        surveyDataId,
    }: {
        compositeId: number,
        surveyDataId: string,
    }): CancelablePromise<CompositeDataCutAdjustmentDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/datacut/{surveyDataId}/adjustment',
            path: {
                'compositeId': compositeId,
                'surveyDataId': surveyDataId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static addCompositeDataCut({
        compositeId,
        surveyDataId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Survey Data Id
         */
        surveyDataId: string,
        requestBody?: {
            surveyId?: string;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/{compositeId}/datacut/{surveyDataId}',
            path: {
                'compositeId': compositeId,
                'surveyDataId': surveyDataId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Composite Data Cut
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompositeDataCut({
        compositeId,
        surveyDataId,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Survey Data Id
         */
        surveyDataId: string,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/composite/{compositeId}/datacut/{surveyDataId}',
            path: {
                'compositeId': compositeId,
                'surveyDataId': surveyDataId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Composite Data Cut
     * @returns CompositeDataCut Success
     * @throws ApiError
     */
    public static updateCompositeDataCut({
        compositeId,
        compositeDataCutId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Composite Data Cut Id
         */
        compositeDataCutId: number,
        requestBody: {
            adjustment: number;
            weight: number;
        },
    }): CancelablePromise<CompositeDataCut> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/composite/{compositeId}/compositeDataCut/{compositeDataCutId}',
            path: {
                'compositeId': compositeId,
                'compositeDataCutId': compositeDataCutId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Composite Comment List
     * @returns any Success
     * @throws ApiError
     */
    public static getCompositeCommentList({
        compositeId,
        limit,
        offset,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        limit?: number,
        offset?: number,
    }): CancelablePromise<{
        rows: Array<CompositeComment>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/comment',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add Composite Comment
     * @returns CompositeComment Success
     * @throws ApiError
     */
    public static addCompositeComment({
        compositeId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        requestBody: {
            text: string;
        },
    }): CancelablePromise<CompositeComment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/composite/{compositeId}/comment',
            path: {
                'compositeId': compositeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update Composite Comment
     * @returns CompositeComment Success
     * @throws ApiError
     */
    public static updateCompositeComment({
        compositeId,
        commentId,
        requestBody,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Comment id
         */
        commentId: number,
        requestBody: {
            text: string;
        },
    }): CancelablePromise<CompositeComment> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/composite/{compositeId}/comment/{commentId}',
            path: {
                'compositeId': compositeId,
                'commentId': commentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete Composite Comment
     * @returns any Success
     * @throws ApiError
     */
    public static deleteCompositeComment({
        compositeId,
        commentId,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Comment id
         */
        commentId: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/composite/{compositeId}/comment/{commentId}',
            path: {
                'compositeId': compositeId,
                'commentId': commentId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get composite history
     * @returns any Success
     * @throws ApiError
     */
    public static getCompositeHistory({
        compositeId,
        limit,
        offset,
        year,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Pagination Limit
         */
        limit?: number,
        /**
         * Pagination Offset
         */
        offset?: number,
        /**
         * Year filter
         */
        year?: number,
    }): CancelablePromise<{
        rows: Array<CompositeHistory>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/history',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'limit': limit,
                'offset': offset,
                'year': year,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export composite to pdf
     * @returns any Success
     * @throws ApiError
     */
    public static exportCompositeToPdf({
        compositeId,
        dataCutDisplayMode,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Data Cut Display Mode
         */
        dataCutDisplayMode: DataCutDisplayMode,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/pdf',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'dataCutDisplayMode': dataCutDisplayMode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export composite to xlsx
     * @returns any Success
     * @throws ApiError
     */
    public static exportCompositeToXlsx({
        compositeId,
        dataCutDisplayMode,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        /**
         * Data Cut Display Mode
         */
        dataCutDisplayMode: DataCutDisplayMode,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/xlsx',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'dataCutDisplayMode': dataCutDisplayMode,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Get Composite Employee Data
     * @returns any Success
     * @throws ApiError
     */
    public static getCompositeEmployeeData({
        compositeId,
        limit,
        offset,
    }: {
        /**
         * Composite id
         */
        compositeId: number,
        limit?: number,
        offset?: number,
    }): CancelablePromise<{
        rows: Array<EmployeeData>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/composite/{compositeId}/employee',
            path: {
                'compositeId': compositeId,
            },
            query: {
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
